import { ArrowDownWideNarrowIcon, ArrowUpDownIcon, ArrowUpWideNarrowIcon } from 'lucide-react';

interface Props {
  isActive: boolean;
  direction: 'asc' | 'desc';
  className?: string;
}

/**
 * Generic sort indicator. Decoupled from any specific sort enum so callers
 * map their own column/order comparison to `isActive` + `direction`.
 *
 * Glyphs:
 *   - Inactive            → `ArrowUpDown`
 *   - Active, ascending   → `ArrowUpWideNarrow`
 *   - Active, descending  → `ArrowDownWideNarrow`
 *
 * The inactive glyph is deliberately not `ListFilter`: that is the Filter
 * control's own icon, and a Sort chip sitting next to one made both read as
 * filters.
 */
export function SortIcon(props: Props) {
  const className = props.className ?? 'size-4';
  if (!props.isActive) {
    return <ArrowUpDownIcon className={className} />;
  }
  return props.direction === 'asc' ? (
    <ArrowUpWideNarrowIcon className={className} />
  ) : (
    <ArrowDownWideNarrowIcon className={className} />
  );
}
